export default __webpack_public_path__ + "static/media/Aspinity_high_res_gray_logo.2f4c468d.jpg";